import { z } from 'zod'

export const createViewSchema = z.object({
  name: z
    .string()
    .min(1, 'View name is required')
    .max(50, 'View name must be 50 characters or less'),
  visibility: z.enum(['PERSONAL', 'SHARED']),
})

export type CreateViewFormValues = z.infer<typeof createViewSchema>

export const renameViewSchema = z.object({
  name: z
    .string()
    .min(1, 'View name is required')
    .max(50, 'View name must be 50 characters or less'),
})

export type RenameViewFormValues = z.infer<typeof renameViewSchema>
